










import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ExamTwitter extends Vue {
  @Prop()
  twitterId: string;

  private twitterPath = '';

  private mounted() {
    this.twitterPath = `https://twitter.com/${this.twitterId}`;
    const scriptTagNode = document.createElement('script');
    scriptTagNode.async = true;
    scriptTagNode.src = 'https://platform.twitter.com/widgets.js';
    scriptTagNode.charset = 'utf-8';
    const tweetBox = document
      .getElementsByClassName('top-sns-tweet-box') as HTMLCollectionOf<Element>;
    tweetBox[0].appendChild(scriptTagNode);
  }
}
